"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = void 0;
var version = '10.6.4'; // Note: This file is automatically generated when building math.js.
// Changes made in this file will be overwritten.

exports.version = version;